import React from "react";
import { Row, Col } from "react-bootstrap";
import { domainData } from "./Data";
import "./DetailedResults.css";

function CreateDomainCard(props) {
  return (
    <Col md={4}>
      <div className="personality-domain-card">
        <div className="domain-name">{props.domainName}</div>
        <div className="domain-desc">{props.desc}</div>
        <div className="domain-traits">
          <p>Traits in this domain: </p>
          <p>{props.traits}</p>
        </div>
      </div>
    </Col>
  );
}

function DetailedResults() {
  return (
    <div className="detailed-results-div">
      <Row>{domainData.map(CreateDomainCard)}</Row>
    </div>
  );
}

export { DetailedResults };
